import React from "react";
import { Modal as AntModal } from "antd";
import styled from "styled-components";
import { OppsFilled } from "@assets";
import { useTranslation } from "react-i18next";

const Modal = styled(AntModal)`
  .ant-modal-content {
    padding: 0;
    padding-top: 15px;
    margin: 0;
  }
  .ant-modal-title {
    text-align: center;
    color: #e9a94d;
    /* color:${(props) => props.theme.golden} !important; */
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 26px;
  }
`;

const ModalFooterContainer = styled.div`
  height: 52px;
  display: flex;
  border-top: 2px solid #f4f1eb;
  background: ${(props) => props.theme.golden};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.textColor};
  border-radius: 0 0 8px 8px;
  cursor: pointer;
`;

const ModalTitle = styled.p`
  color: ${(props) => props.theme.primarySolid};
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
`;

const ModalText = styled.p`
  color: #858585;
  font-weight: 400;
  font-size: 14px;
  display: block;
  margin-bottom: 20px;
  padding: 0 30px;
`;

const ErrorModal = ({ open, onOk, label, title }) => {
  const { t } = useTranslation();

  return (
    <Modal
      centered
      destroyOnClose
      closable={false}
      open={open}
      width={350}
      onOk={onOk}
      footer={null}
    >
      <div style={{ textAlign: "center" }}>
        <ModalTitle>{title}</ModalTitle>
        <OppsFilled width={80} height={80} />
        <ModalText>{label}</ModalText>
      </div>
      <ModalFooterContainer onClick={onOk}>
        {t("common.ok")}
      </ModalFooterContainer>
    </Modal>
  );
};

export default ErrorModal;
